import React from 'react';
import { MonitorMapContext } from './MonitorMapContext';
const useMonitorMap = () => React.useContext(MonitorMapContext);
export default useMonitorMap;
